import PageProxy from '@/components/page-types/page-proxy'

export { fetchStaticProps as getStaticProps } from '@/data/fetch-static-props'
export { fetchStaticPaths as getStaticPaths } from '@/data/fetch-static-paths'

export default PageProxy
